import { stringOrUndefined } from "@faire/retailer-visitor-shared/lib/stringOrUndefined";
import { QueryParameters } from "@faire/web-api--source/api/email/preferences/get";
import { useQuery as useQueryPreferences, getQueryKey as getQueryPreferencesKey } from "@faire/web-api--source/api/email/preferences/get-hooks";
import { useQueryClient } from "@tanstack/react-query";
import qs from "qs";
import { useCallback } from "react";
import { useLocation } from "react-router-dom";
export var useEmailPreferencesQuery = function() {
    var location = useLocation();
    var outgoingEmail = stringOrUndefined(qs.parse(location.search).outgoing_email);
    var preferencesQueryParameters = QueryParameters.build({
        outgoing_email: outgoingEmail
    });
    var queryClient = useQueryClient();
    var _useQueryPreferences = useQueryPreferences(preferencesQueryParameters, {
        staleTime: Infinity
    }), emailPreferencesResponse = _useQueryPreferences.data, isQueryPreferencesLoading = _useQueryPreferences.isLoading, isQueryPreferencesError = _useQueryPreferences.isError;
    var updateEmailPreferencesQuery = useCallback(function(updateValueOrFn) {
        queryClient.setQueryData(getQueryPreferencesKey(preferencesQueryParameters), updateValueOrFn);
    }, [
        queryClient,
        preferencesQueryParameters
    ]);
    return {
        emailPreferencesResponse: emailPreferencesResponse,
        preferencesQueryParameters: preferencesQueryParameters,
        isQueryPreferencesLoading: isQueryPreferencesLoading,
        isQueryPreferencesError: isQueryPreferencesError,
        updateEmailPreferencesQuery: updateEmailPreferencesQuery
    };
};
